// Shared function for hiding bootstrap dropdown menus
const hideDropdown = (id)=>{
  const el = document.getElementById(id)
  const instance = bootstrap.Dropdown.getOrCreateInstance(el)
  instance.hide()
}

export default hideDropdown